import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingInlineProps {
  size?: 'sm' | 'md';
  message?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6'
};

export const LoadingInline: React.FC<LoadingInlineProps> = ({
  size = 'md',
  message,
  className = ''
}) => {
  return (
    <div className={`inline-flex items-center ${className}`}>
      <Loader2 className={`${sizeClasses[size]} animate-spin text-blue-400`} />
      {message && (
        <span className="ml-2 text-foreground-secondary text-sm">{message}</span>
      )}
    </div>
  );
};
